import React from 'react'
import moment from 'moment'
import {removeZeros} from '../../../utils/misc'
import {getUserSettings} from '../../../storage'

class PurchaseA4 extends React.Component {

  render() {

    let company = this.props.company
    let purchase = this.props.purchase

    let settings = getUserSettings()

    let purchase_date = moment(purchase.date).format('D-MM-YYYY')
    let billto
    let shipping_address
    let from_address
    let optionalRow

    if(typeof purchase.supplier !== "undefined" && purchase.supplier !== null) {
      from_address = <div className="">
      <div className="company-address gray">
        {purchase.supplier.address}
      </div>
      <div className="company-state gray">
          {purchase.supplier.state} - <span className="company-pin gray">{purchase.supplier.pin}</span>
      </div>
      <div className="company-email gray">
        {purchase.supplier.email}
      </div>
      <div className="company-phone gray">
        {purchase.supplier.phone}
      </div>
      <div className="company-state gray">
         GSTIN - {purchase.supplier.gstin}
      </div>
      </div>

    }


    if(typeof company !== "undefined" && company !== null) {

      let company_gstin

      if(typeof company.gstin !== "undefined" && company.gstin !== null) {
        company_gstin = "GSTIN-"+company.gstin
      }

        shipping_address = <div>  <div className="gray">
                {company.company_name}
          </div>
          <div className="gray">
              {company.address}
          </div>
          <div className="gray">
              {company.city}
          </div>
          <div className="gray">
              {company.state}-{company.pin}
          </div></div>


      billto = <div className="row">
      <div className="col-xs-6">
        <div className="">
        <strong>Bill To</strong>
          <div className="gray">
              {company.company_name}
          </div>
          <div className="gray">
              {company.address}
          </div>
          <div className="gray">
              {company.city}
          </div>
          <div className="gray">
              {company.state}-{company.pin}
          </div>
          <div className="gray">
             {company_gstin}
          </div>
        </div>
      </div>

      <div className="col-xs-6">
        <div className="">
        <strong>Ship To</strong>
          {shipping_address}
        </div>
      </div>

      </div>

    }


    let items
    let summaryTotal=0, roundOffValue
    let additional_charges

    if(purchase.purchaseitem_set.length > 0) {

      purchase.purchaseitem_set.sort((a,b)=>{
        return a.tableIndex - b.tableIndex
      })

      items = purchase.purchaseitem_set.map((purchaseitem, index)=>{
        let discountCol, cgstcol, sgstcol, igstcol, cessCol, tcsCol
        if(purchaseitem.discount_value > 0) {
            discountCol = <td className="text-right">{removeZeros(purchaseitem.discount_value)}</td>
        }
        else {
          discountCol = <td className="text-right"></td>
        }

        if(purchase.is_igst) {
          if(purchaseitem.igst_amount > 0) {
            igstcol = <td className="text-right">
              {Number(purchaseitem.igst_amount)} ({Number(purchaseitem.gst.igst)}%)

                 </td>
          }
          else {
            igstcol = <td className="text-right"></td>
          }

        }
        else {

          if(purchaseitem.cgst_amount > 0) {
            cgstcol=  <td className="text-right">{Number(purchaseitem.cgst_amount)} ({Number(purchaseitem.gst.cgst)}%)</td>
          }
          else {
            cgstcol= <td className="text-right"></td>
          }

          if(purchaseitem.sgst_amount > 0) {
            sgstcol= <td className="text-right">{Number(purchaseitem.sgst_amount)} ({Number(purchaseitem.gst.sgst)}%)</td>
          }
          else {
            sgstcol = <td className="text-right"></td>
          }
        }

        if(purchase.add_cess){
          let specific_cess_amount = ""
          if(purchaseitem.specific_cess_amount) {
            specific_cess_amount = "+ " + purchaseitem.specific_cess_amount+""
          }
          cessCol = <td className="text-right">{Number(purchaseitem.cess_amount)} ({Number(purchaseitem.cess_percentage)}%) {specific_cess_amount}</td>
        }
        if(purchase.add_tcs) {
          tcsCol = <td className="text-right">{Number(purchaseitem.tcs_value)} ({Number(purchaseitem.tcs_pct)}%)</td>
        }

        let item_unit
        let unit_price = Number(purchaseitem.purchase_basic_rate),
        taxable_price = Number(purchaseitem.price),
        item_total = Number(purchaseitem.total)

        return <tr key={index}><td>{purchaseitem.tableIndex}</td>
        <td><div>{purchaseitem.name}</div></td>
        <td><div>{purchaseitem.hsn}</div></td>
        <td className="text-right">
          <div>{Number(purchaseitem.quantity)}</div>
          <div>{item_unit}</div>
        </td>
        <td className="text-right">{unit_price}</td>
          {discountCol}
          <td className="text-right">{taxable_price}</td>
          {cgstcol}{sgstcol}{igstcol}{cessCol}{tcsCol}
          <td className="text-right">{item_total}</td>
        </tr>
      })

      for (var i = 0; i < purchase.purchaseitem_set.length; i++) {
        const pi = purchase.purchaseitem_set[i]
        summaryTotal = summaryTotal + parseFloat(pi.total)
      }

      if(purchase.additional_charges && purchase.additional_charges.length) {

        for (var i = 0; i < purchase.additional_charges.length; i++) {
          const charge = purchase.additional_charges[i]
             summaryTotal = summaryTotal + parseFloat(charge.total)
        }
      }
      summaryTotal = parseFloat(summaryTotal).toFixed(2)
      roundOffValue= parseFloat(purchase.total) - parseFloat(summaryTotal)
      if(roundOffValue >= 0) {
          roundOffValue =  <div className="row">
              <div className="col-xs-6">
                <strong>Round off</strong>
              </div>
              <div className="col-xs-6 text-right">
                 {"+" + parseFloat(roundOffValue).toFixed(2)}
              </div>
          </div>
      }
      else {
        roundOffValue =  <div className="row">
            <div className="col-xs-6">
              <strong>Round off</strong>
            </div>
            <div className="col-xs-6 text-right">
               {parseFloat(roundOffValue).toFixed(2)}
            </div>
        </div>
      }

    }


    let discount
    if(purchase.totalDiscount > 0) {
      discount = <div className="row">
          <div className="col-xs-6">
            <strong>Discount  </strong>
          </div>
          <div className="col-xs-6 text-right">
             &#8377; {purchase.totalDiscount}
          </div>
      </div>
    }

    let cess
    if(purchase.add_cess) {
      cess = <div className="row">
        <div className="col-xs-6">
          <strong>Cess  </strong>
        </div>
        <div className="col-xs-6 text-right">
           &#8377; {purchase.totalCess}
        </div>
        </div>
    }
    let tcs
    if(purchase.add_tcs){
      tcs = <div className="row">
        <div className="col-xs-6">
          <strong>TCS  </strong>
        </div>
        <div className="col-xs-6 text-right">
           &#8377; {purchase.totalTcs}
        </div>
        </div>
    }


    let totalBeforeDiscount = parseFloat(parseFloat(purchase.totalPrice) + parseFloat(purchase.totalDiscount)).toFixed(2)

    let cgst_header, sgst_header, igst_header, cess_header, tcs_header
    if(purchase.is_igst) {
      igst_header = <th className="text-right">IGST</th>
    }
    else {
      cgst_header = <th className="text-right">CGST</th>
      sgst_header = <th className="text-right">SGST</th>

    }

    if(purchase.add_cess) {
      cess_header = <th className="text-right">Cess</th>
    }
    if(purchase.add_tcs) {
      tcs_header = <th className="text-right">Tcs</th>
    }

    let serial = purchase.serial
    if(typeof purchase.supplier_bill_no !== "undefined") {
      serial = purchase.supplier_bill_no
    }

    let purchase_additional_params = purchase.additional_params
    let p_addons_list
    if(purchase_additional_params && purchase_additional_params.length) {
      p_addons_list = purchase_additional_params.map((param,id)=>{
        return <div className="text-right">{param.key} {param.value}</div>
      })
    }

    let purchase_additional_charges = purchase.additional_charges
    let purchase_additional_charges_header
    let p_addons_charges
    let purchase_additional_charges_title

    if(purchase_additional_charges && purchase_additional_charges.length) {
      purchase_additional_charges_title = <div>
      Additonal Charges
      </div>
      purchase_additional_charges_header = <tr className="active">
        <th>
          Name
        </th>
        <th>
          Amount
        </th>
        <th>
          Tax
        </th>
        <th>
          Total
        </th>
      </tr>
      p_addons_charges = purchase_additional_charges.map((param,id)=>{
        return <tr key={id}>
        <td>
        {param.key}
        </td>
        <td>
        {param.value}
        </td>
        <td>
        {param.tax_pct}%
        </td>
        <td>
        {param.total}
        </td>
        </tr>
      })

      purchase_additional_charges = <div>
      {purchase_additional_charges_title}
      <table className="table table-condensed">
        <thead>
        {purchase_additional_charges_header}
        </thead>
        <tbody>
        {p_addons_charges}
        </tbody>

      </table>
      </div>

    }


    let supplier = purchase.supplier

    if(typeof settings !== "undefined" && settings !== null) {

        let declartion, bankDetails, pan
        if(settings.show_purchase_pan) {
          pan = <div>Company Pan - {company.pan}</div>
        }
        if(settings.show_purchase_declaration) {
          declartion = <div><u>Terms and Conditions</u>
              <div><p>{settings.purchase_declaration}</p></div>
      </div>
        }

        if(settings.show_purchase_bankdetails) {
          bankDetails = <div><div className="row">
              <div className="col-xs-6">Bank Name</div>
              <div className="col-xs-6">{company.bank_name}</div>
              </div>
              <div className="row">
                <div className="col-xs-6">Account No</div>
                <div className="col-xs-6">{supplier.account_no}</div>
              </div>
              <div className="row">
                <div className="col-xs-6">IFSC</div>
                <div className="col-xs-6">{supplier.ifsc_code}</div>
              </div>
              <div className="row">
                <div className="col-xs-6">Branch </div>
                <div className="col-xs-6">{supplier.branch_name}</div>
              </div>

              </div>
        }
        optionalRow = <div className="row space-medium small" >
          <div className="col-xs-6">
            {pan}
            {declartion}
          </div>
          <div className="col-xs-6">
            {bankDetails}
          </div>
        </div>


    }


    let supplierName
    if(typeof purchase.supplier !== "undefined" && purchase.supplier !== null ) {
      supplierName = purchase.supplier.name
    }

      return <div  className="preview-a4" >

              <div className="row">
                <div className="col-xs-6">
                  <div className="company-name text-uppercase">
                    {supplierName}
                  </div>
                  {from_address}

                </div>
                <div className="col-xs-6">
                  <div className="invoice-name text-right">
                    {serial}
                  </div>
                  <div className="gray text-right">
                  Date: {purchase_date}
                  </div>
                  {p_addons_list}
                </div>
              </div>


              <hr/>

              {billto}

              <div className="row space-medium">
              <div className="col-xs-12">
              <table className="table table-bordered table-condensed">
                <thead>
                  <tr className="active">
                    <th className="table-item">S.No</th>
                    <th className="table-item">Item Name</th>
                    <th className="table-item">HSN</th>
                    <th className="text-right">Qty</th>
                    <th className="text-right">Unit Price</th>
                    <th className="text-right">Discount</th>
                    <th className="text-right">Taxable Price</th>
                    {cgst_header}{sgst_header}{igst_header}{cess_header}{tcs_header}
                    <th className="text-right">Total</th>
                  </tr>
                </thead>
                <tbody>
                  {items}
                </tbody>
              </table>
              </div>
              </div>


              <div className="row space-small">
              <div className="col-sm-6">
              {purchase_additional_charges}

              </div>
              <div className="col-sm-6">

                  <div className="row">
                      <div className="col-xs-6">
                        <strong>Amount  </strong>
                      </div>
                      <div className="col-xs-6 text-right">
                         &#8377; {totalBeforeDiscount}
                      </div>
                  </div>

                  {discount}

                  <div className="row">
                      <div className="col-xs-6">
                        <strong>GST  </strong>
                      </div>
                      <div className="col-xs-6 text-right">
                         &#8377; {purchase.totalTax}
                      </div>
                  </div>

                  {cess}
                  {tcs}
                  {roundOffValue}

                  <div className="row">
                      <div className="col-xs-6">
                      <strong>Total  </strong>
                      </div>
                      <div className="col-xs-6 text-right">
                         &#8377; {purchase.total}
                      </div>
                  </div>

              </div>
              </div>

              {optionalRow}

              <div className="row space-small">
              <div className="col-xs-6 col-xs-offset-6">

              <div className=" text-center">
              Authorized Signature
              </div>
              </div>
              </div>


      </div>

  }
}

export default PurchaseA4



// WEBPACK FOOTER //
// ./src/components/purchase/previews/purchasea4.js